import React, { useState, useEffect } from "react";
import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { MyProSidebarProvider } from "./pages/global/sidebar/sidebarContext";
import { useAuth } from "./AuthProvider";

import Topbar from "./pages/global/Topbar";
import SignIn from "./pages/signin/signin";
import ChangePassword from "./pages/ChangePassword/changePassword";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import OrganizationForm from "./pages/Organization_Role/OrganisationForm/OrganisationForm";
import OrganizationProfile from "./pages/Profile/OrganizationProfile/OrganizationProfile";
import PrincipalDashboard from "./pages/Principal_Role/Principal_Dashboard/principalDashboard";

import UploadDocs from "./pages/Fees_Admission_Department/UploadDocuments/UploadDocuments";
import Expenses from "./pages/Fees_Admission_Department/Expenses/Expenses";
import AllStudentList from "./pages/Fees_Admission_Department/Students/AllStudents";
import StudentDetailView from "./pages/Fees_Admission_Department/Students/StudentDetails";
import NewAdmissionForm from "./pages/Fees_Admission_Department/Students/AdmissionForm";
import FeesDetailsList from "./pages/Fees_Admission_Department/TotalFeesDetailsList/FeeDetailsList";
// import RolesRegistrationForm from "./pages/Principal_Role/Admission_StoreRoleRegistration.js/RolesRegistrationForm";
import BonafideCertificate from "./pages/Fees_Admission_Department/UploadDocuments/Bonafied";
import AbsentsList from "./pages/Hrbp_Role/AbsentsList/absentsList";
import EmployeeAttendance from "./pages/Hrbp_Role/Attedance/attendance";
import Dashboard from "./pages/Hrbp_Role/dashboard/dashboard";
import Employee from "./pages/Hrbp_Role/Employee/employee";
import EmployeeAttendanceDetails from "./pages/Hrbp_Role/EmployeeAttendanceDetails/EmployeeAttendanceDetails";
import EmployeeDetails from "./pages/Hrbp_Role/EmployeeDetails/EmployeeDetails";
import EmployeeRegForm from "./pages/Hrbp_Role/EmployeeRegistration/EmployeeRegistration";
import HolidayCalendar from "./pages/Hrbp_Role/HolidayCalendar/holidayCalendar";
import EmployeeLeave from "./pages/Hrbp_Role/Leave/leave";
import EmployeePaySlip from "./pages/Hrbp_Role/PaySlip/paySlips";
import PaySlipDoc from "./pages/Hrbp_Role/PaySlipDocument/DocPaySlip";
import SalaryReport from "./pages/Hrbp_Role/Reports/SalaryReport";

import BranchTransfer from "./pages/Fees_Admission_Department/Students/BranchTransfer";
import StudentPromotion from "./pages/Fees_Admission_Department/Students/StudentPromotion";
import StudentTransferList from "./pages/Fees_Admission_Department/Students/StudentTransferList";
import Admission_DashBoard from "./pages/Fees_Admission_Department/Fees_Admission_DashBoard/Fees_Admission_DashBoard";
import StudentTransferForm from "./pages/Fees_Admission_Department/Students/StudentTransfer";
import PaidFeesList from "./pages/Fees_Admission_Department/TotalFeesDetailsList/PaidFeesList";
import UnPaidFeesList from "./pages/Fees_Admission_Department/TotalFeesDetailsList/UnPaidFeesList";
import BusFeesDetailsList from "./pages/Fees_Admission_Department/BusFeeDetailsList/BusFeeDetailsList";
import { BusFeeRegistrationForm } from "./pages/Fees_Admission_Department/BusFeeDetailsList/BusFeeRegForm";
import PaidBusFeeList from "./pages/Fees_Admission_Department/BusFeeDetailsList/PaidBusFeeList";
import UnpaidBusFeeList from "./pages/Fees_Admission_Department/BusFeeDetailsList/UnPaidBusFeeList";
import BonafideDoc from "./pages/Fees_Admission_Department/UploadDocuments/BonafiedDoc";




import AllClassSchedules from "./pages/Roles/Teacher_Role/AllClassSchedules/AllClassSchedules";
import AddNewClassSchedules from "./pages/Roles/Teacher_Role/AllClassSchedules/AddNewClassSchedule";
import BusExpenses from "./pages/Fees_Admission_Department/BusFeeDetailsList/BusExpenses";
import TransferCertificate from "./pages/Fees_Admission_Department/UploadDocuments/TransferCertificate";
import TransportDashboard from "./pages/Fees_Admission_Department/BusFeeDetailsList/TransportDashboard";
import ScheduleAndMeetDashboard from "./pages/Roles/ScheduleAndMeetings_Role/ScheduleAndMeetings_Dashboard";
import TeachersClassSchedule from "./pages/Roles/Teacher_Role/TeacherClassSchedule/TeacherClassSchedule";
import TeacherTimeTable from "./pages/Roles/Teacher_Role/AllClassSchedules/TeacherTimeTable";
import ClassTimeTable from "./pages/Roles/Teacher_Role/AllClassSchedules/ClassTimeTable";
import SchedulingRouteList from "./pages/Roles/Transport_Role/SchedulingRouteList";
import { SchedulingRouteForm } from "./pages/Roles/Transport_Role/SchedulingRouteForm";
import DriversList from "./pages/Roles/Transport_Role/DriversList";
import { DriverRegForm } from "./pages/Roles/Transport_Role/DriversRegForm";
import TeacherMeeting from "./pages/Roles/ScheduleAndMeetings_Role/Meetings/TecherMeetings";
import ParentMeetings from "./pages/Roles/ScheduleAndMeetings_Role/Meetings/ParentsMeeting";
import Notification from "./pages/Roles/ScheduleAndMeetings_Role/Notifications/Notifications";
import OrganizationAdminRegister from "./pages/Organization_Role/OganizationAdminRegister/OrganizationPrincipalRegistrationForm";
import OrganizationPrincipalRegistrationForm from "./pages/Organization_Role/OganizationAdminRegister/OrganizationPrincipalRegistrationForm";
import OrganizationDashboard from "./pages/Organization_Role/OrganizationDashboard/OrganizationDashboard";
import AllExaminationScheduleList from "./pages/Roles/Examination_Role/AllExaminationScheduleList";
import AllExaminationScheduleForm from "./pages/Roles/Examination_Role/AllExaminationScheduleForm";
import ExaminationDashboard from "./pages/Roles/Examination_Role/ExaminationDashboard/ExaminationDshboard";
import ExaminationMiniDashboard from "./pages/Roles/Examination_Role/ExaminationDashboard/ExaminationMiniDashboard";
import TodayandTmrwExaminationScheduleList from "./pages/Roles/Examination_Role/TodayandTmrwExaminationScheduleList";
import Unit1ExaminationScheduleList from "./pages/Roles/Examination_Role/Unit_1ExaminationSchedule/Unit1ExaminationScheduleList";
import Unit1ExaminationResultList from "./pages/Roles/Examination_Role/Unit_1ExaminationSchedule/Unit1ExaminationResults/Unit1ExaminationResultsList";
import Unit1ExaminationIndividualResultList from "./pages/Roles/Examination_Role/Unit_1ExaminationSchedule/Unit1ExaminationResults/Unit1ExaminationIndividualResultsList";

import Complaint from "./pages/Principal_Role/Complaints/Complaints";
import ProgressCard from "./pages/Roles/Examination_Role/ProgressCard/ProgressCard";
import ExaminationComplaints from "./pages/Roles/Examination_Role/Examination_Complaints/Examination_Complaints";
import SchedulesAndMeetComplaints from "./pages/Roles/ScheduleAndMeetings_Role/SchedulesAndMeet_Complaints/SchedulesAndMeet_Complaints";
import AdmissionComplaints from "./pages/Fees_Admission_Department/Admission_Complaints/Admission_Complaints";
import TransportComplaints from "./pages/Roles/Transport_Role/Transport_Complaints/Transport_Complaints";
import PresentStudentsList from "./pages/Principal_Role/TotalStudentsList/PresentStudentsList";
import AbsentStudentsList from "./pages/Principal_Role/TotalStudentsList/AbsentStudentsList";
import TotalTeachersList from "./pages/Principal_Role/TotalTeachersList/TotalTeachersList";
import PresentTeachersList from "./pages/Principal_Role/TotalTeachersList/PresentTeachersList";
import AbsentTeachersList from "./pages/Principal_Role/TotalTeachersList/AbsentTeachersList";
import TotalBusAttendanceList from "./pages/Fees_Admission_Department/BusFeeDetailsList/BusAttendanceList/TotalBusAttendanceList";
import PresentBusAttendeesList from "./pages/Fees_Admission_Department/BusFeeDetailsList/BusAttendanceList/PresentBusList";
import AbsentBusAttendeesList from "./pages/Fees_Admission_Department/BusFeeDetailsList/BusAttendanceList/AbsentBusList";
import NewRegisterdStudents from "./pages/Fees_Admission_Department/Students/NewRegisteredStudents";
import ScheduleNoticeBoard from "./pages/Roles/ScheduleAndMeetings_Role/ScheduleNoticeBoard/ScheduleNoticeBoard";
import NoticeBoard from "./pages/Principal_Role/NoticeBoard/NoticeBoard";
import TransferCertificateList from "./pages/Fees_Admission_Department/TransferCertificateList/TransferCertificateList";
import StudentPromotionList from "./pages/Fees_Admission_Department/Students/StudentPromotionList";
import PrincipalRoleRegistrations from "./pages/Principal_Role/RoleRegistrations/PrincipalRoleRegistrations";

import RoleRegistrationList from "./pages/Principal_Role/RoleRegistrations/RoleRegistrationList";
import { BusScheduleRouteForm } from "./pages/Roles/Transport_Role/BusScheduleRouteForm";
import StudentBranchTransferList from "./pages/Fees_Admission_Department/Students/StudentBranchTransferList";
import NonTeachingStaffMeetings from "./pages/Roles/ScheduleAndMeetings_Role/Meetings/NonTeachingStaff";
import IndividualComplaintsList from "./pages/Principal_Role/Complaints/IndividualComplaintsList";
import ExistingStudentsList from "./pages/Fees_Admission_Department/Students/ExistingStudentsList";
import ClassTeacherForm from "./pages/Principal_Role/TotalTeachersList/ClassTeacherForm";
import ClassTeachersList from "./pages/Principal_Role/TotalTeachersList/ClassTeachersList";
import StudentUpdateDetails from "./pages/Fees_Admission_Department/Students/StudentUpdateDetails";
import PrincipalsList from "./pages/Organization_Role/PrincipalsList/PrincipalsList";
import PrincipalDetails from "./pages/Organization_Role/PrincipalsList/PrincipalDetails";
import Settings from "./pages/Principal_Role/Settings/Settings";
import IntermediateSettings from "./pages/Principal_Role/Settings/IntermediateSettings";
import AllStockItemsListForStudents from "./pages/Store_Role/TotalStudentsList/AllStockItemsListForStudents";
import SoldItems from "./pages/Store_Role/SoldItems/SoldItems";
import SoldItemsTemplate from "./pages/Store_Role/SoldItems/SoldItemsTemplate";
import StockItems from "./pages/Store_Role/StockItems/StockItems";
import PurchaseInvoiceList from "./pages/Store_Role/PurchaseInoviceList/PurchaseInvoiceList";
import StoreDashboard from "./pages/Store_Role/StoreDashboard/StoreDashboard";
import Store_Expenses from "./pages/Store_Role/StoreExpenses/StoreExpenses";
import StoreTotalStudentsList from "./pages/Store_Role/TotalStudentsList/StoreTotalStudentsList";
import AdmissionFeePayments from "./pages/Fees_Admission_Department/Students/AdmissionFeePayments";

import StudentFeeConcessionForm from "./pages/Fees_Admission_Department/Students/StudentFeeConcessionForm";
import StudentFeeConcessionList from "./pages/Fees_Admission_Department/Students/StudentFeeConcessionList";
import ConcessionFeeList from "./pages/Principal_Role/ConsessionFeeList/ConcessionFeeList";
import PurchaseReceipt from "./pages/Store_Role/PurchaseInoviceList/PurchaseReceipt";
import Organization_PrincipalDashboard from "./pages/Organization_Role/Organization_PrincipalDashboard/Organization_PrincipalDashboard";
import Hallticketslist from "./pages/Roles/Examination_Role/HallTicket/HallticketsList";
import BusTracking from "./pages/Principal_Role/BusTracking/BusTracking";
import PurchaseReceiptDummy from "./pages/Store_Role/PurchaseInoviceList/PurchaseReceiptDummy";
import BusFeeConcessionForm from "./pages/Fees_Admission_Department/BusFeeDetailsList/BusFeeConcession/BusFeeConcessionForm";
import BusFeeConcessionList from "./pages/Fees_Admission_Department/BusFeeDetailsList/BusFeeConcession/BusFeeConcessionList";
import ConcessionBusFeeList from "./pages/Principal_Role/ConsessionFeeList/ConsessionBusFeeList";
import HallTicketTemplate from "./pages/Roles/Examination_Role/HallTicket/HallTicketTemplate";
import DigitalClasses from "./pages/Roles/ScheduleAndMeetings_Role/DigitalClasses/DigitalClasses";
import OrgDashTotalTeachersList from "./pages/Organization_Role/OrgDashTeachersOverview/OrgDashTotalTeachersList";
import OrgDashPresentTeachersList from "./pages/Organization_Role/OrgDashTeachersOverview/OrgDashPresentTeachersList";
import OrgDashAbsentTeachersList from "./pages/Organization_Role/OrgDashTeachersOverview/OrgDashAbsentTeachersList";
import OrgDashTotalStudentsList from "./pages/Organization_Role/OrgDashStudentsOverView/OrgDashTotalStudentsList";
import OrgDashNewStudentsList from "./pages/Organization_Role/OrgDashStudentsOverView/OrgDashNewStudentsList";
import OrgDashExistingStudentsList from "./pages/Organization_Role/OrgDashStudentsOverView/OrgDashExistingStudentsList";
import OrgDashTotalTutionFee from "./pages/Organization_Role/OrgDashTutionFeeOverView/OrgDashTotalTutionFee";
import OrgDashPaidTutionFee from "./pages/Organization_Role/OrgDashTutionFeeOverView/OrgDashPaidTutionFee";
import OrgDashUnPaidTutionFee from "./pages/Organization_Role/OrgDashTutionFeeOverView/OrgDashUnPaidTutionFee";
import OrgDashTotalBusFee from "./pages/Organization_Role/OrgDashBusFeeOverView/OrgDashTotalBusFee";
import OrgDashPaidBusFee from "./pages/Organization_Role/OrgDashBusFeeOverView/OrgDashPaidBusFee";
import OrgDashUnPaidBusFee from "./pages/Organization_Role/OrgDashBusFeeOverView/OrgDashUnPaidBusFee";
import Bonafide3 from "./pages/Fees_Admission_Department/UploadDocuments/Bonafide3";
import Bonafide2 from "./pages/Fees_Admission_Department/UploadDocuments/Bonafide2";
import TransferCertificate2 from "./pages/Fees_Admission_Department/UploadDocuments/TransferCertificate2";
import FeePayments from "./pages/Fees_Admission_Department/AllFeePayments/FeePayments";
import StudentPaymentList from "./pages/Fees_Admission_Department/AllFeePayments/StudentPaymentsList";
import StudentPaymentsTransactionList from "./pages/Fees_Admission_Department/AllFeePayments/StudentPaymentsTransactionList";
import StudentPaymentsReceipts from "./pages/Fees_Admission_Department/AllFeePayments/StudentPaymentsReceipts";
import ExamFees from "./pages/Fees_Admission_Department/AllFeePayments/ExamFees";
import OtherFees from "./pages/Fees_Admission_Department/AllFeePayments/OtherFees";
import PrincipalReports from "./pages/Reports/PrincipalReports/PrincipalReports";
import AdmissionReportsScreen from "./pages/Reports/PrincipalReports/AdmissionReports/AdmissionReportsScreen";
import NewAdmissionReports from "./pages/Reports/PrincipalReports/AdmissionReports/NewAdmissionReports";
import AdmissionFeePaidReports from "./pages/Reports/PrincipalReports/AdmissionReports/AdmissionFeePaidReports";
import TuitionFeePaidReports from "./pages/Reports/PrincipalReports/AdmissionReports/TuitionFeePaidReports";
import TuitionFeeUnpaidReports from "./pages/Reports/PrincipalReports/AdmissionReports/TuitionFeeUnpaidReports";
import BusFeePaidReports from "./pages/Reports/PrincipalReports/AdmissionReports/BusFeePaidReports";
import BusFeeUnpaidReports from "./pages/Reports/PrincipalReports/AdmissionReports/BusFeeUnpaidReports";
import AdmissionExpensesReports from "./pages/Reports/PrincipalReports/AdmissionReports/AdmissionExpensesReports";
import HRBPReportsScreen from "./pages/Reports/PrincipalReports/HRBPReports/HRBPReportsScreen";
import EmployeeSalaryReports from "./pages/Reports/PrincipalReports/HRBPReports/EmployeeSalaryReports";
import EmployeePresentReports from "./pages/Reports/PrincipalReports/HRBPReports/EmployeePresentReports";
import EmployeeAbsentReports from "./pages/Reports/PrincipalReports/HRBPReports/EmployeeAbsentReports";
import TransportReportsScreen from "./pages/Reports/PrincipalReports/TransportReports/TransportReportsScreen";
import StudentBusReports from "./pages/Reports/PrincipalReports/TransportReports/StudentBusReports";
import StudentsBusWiseReports from "./pages/Reports/PrincipalReports/TransportReports/StudentBusWiseReports";
import TransportExpensesReports from "./pages/Reports/PrincipalReports/TransportReports/TransportExpensesReports";
import ExpensesReportsScreen from "./pages/Reports/PrincipalReports/ExpensesReports/ExpensesReportsScreen";
import StoreReportsScreen from "./pages/Reports/PrincipalReports/StoreReports/StoreReportsScreen";
import PurchaseReports from "./pages/Reports/PrincipalReports/StoreReports/PurchaseReports";
import SoldItemsReports from "./pages/Reports/PrincipalReports/StoreReports/SoldItemsReports";
import StockItemsMaterialReports from "./pages/Reports/PrincipalReports/StoreReports/StockItemsMaterialReports";
import StoreExpensesReports from "./pages/Reports/PrincipalReports/StoreReports/StoreExpensesReports";
import HRBPExpensesReportScreen from "./pages/Reports/PrincipalReports/ExpensesReports/HRBPExpnsesReportScreen";
import StoreExpensesReportsScreen from "./pages/Reports/PrincipalReports/ExpensesReports/StoreExpensesReportsScreen";
import SuperAdminDashboard from "./pages/SuperAdmin/SuperAdminDashboard";
import Packages from "./pages/SuperAdmin/Packages";
import SuperAdminOrganizationsList from "./pages/SuperAdmin/SuperAdminOrganizationsList";
import SuperAdminPrincipalsList from "./pages/SuperAdmin/SuperAdminPrincipalsList";
import Trips from "./pages/Roles/Transport_Role/Trips";
import AssignExamSubjectMarks from "./pages/Roles/Examination_Role/AssignExamSubjectMarks/AssignExamSubjectMarksForm";
import AssignExamSubjectMarksForm from "./pages/Roles/Examination_Role/AssignExamSubjectMarks/AssignExamSubjectMarksForm";
import AssigenedExamSubjectMarksList from "./pages/Roles/Examination_Role/AssignExamSubjectMarks/AssigenedExamSubjectMarksList";
import CashFeeReceipt from "./pages/Fees_Admission_Department/AllFeePayments/cashFeeReceipt";
import StudentsAddBusList from "./pages/Fees_Admission_Department/BusFeeDetailsList/StudentsAddBusList";
import BooksFeeList from "./pages/Fees_Admission_Department/BooksFee/BooksFeeList";
import IndividualStudentsBooksList from "./pages/Fees_Admission_Department/BooksFee/IndividualStudentsBooksList";
import BooksReceipt from "./pages/Fees_Admission_Department/BooksFee/BooksReceipt";
import LeisurePeriod from "./pages/Principal_Role/LeisurePeriod/LeisurePeriod";
import HostelFeesList from "./pages/Fees_Admission_Department/HostelFees/HostelFeesList";
import { HostelRegistrationForm } from "./pages/Fees_Admission_Department/HostelFees/HostelRegistrationForm";
import Teacherlist from "./pages/Principal_Role/LeisurePeriod/Teacherlist";
import StudentMarksUpload from "./pages/Roles/Examination_Role/MarksUpload/StudentMarksUpload";
import StudentReportCard from "./pages/Roles/Examination_Role/ProgressCard/StudentReportCard";
import SubjectCategoryMarksType from "./pages/Roles/Examination_Role/AssignExamSubjectMarks/SubjectCategoryMarksType";
import StudentMarksList from "./pages/Roles/Examination_Role/MarksUpload/StudentMarksList";
import StudentIndividualMarksList from "./pages/Roles/Examination_Role/MarksUpload/StudentIndividualMarksList";

import HallTicketTemplate2 from "./pages/Roles/Examination_Role/HallTicket/HallTicketTemplate2";
import HallTicketTemplate3 from "./pages/Roles/Examination_Role/HallTicket/HallTicketTemplate3";
import ProgressCard2 from "./pages/Roles/Examination_Role/ProgressCard/ProgressCard2";
import LoadingPage from "./pages/Principal_Role/LoadingPage/LoadingPage";
import StudentAttendance from "./pages/Principal_Role/StudentAttendance/StudentAttendance";
import StudentAttendanceReport from "./pages/Principal_Role/StudentAttendance/StudentAttendanceReport";
import StudentAttendanceCalendar from "./pages/Principal_Role/StudentAttendance/StudentAttendanceCalender";
import PrincipalEditTuitionFeeList from "./pages/Principal_Role/UpdateFeeDetailsList/PrincipalEditTuitionFeeList";
import PrincipalEditBusFeeList from "./pages/Principal_Role/UpdateFeeDetailsList/PrincipalEditBusFeeList";
import PrincipalEditFeeTransactionList from "./pages/Principal_Role/UpdateFeeDetailsList/PrincipalEditFeeTransactionList";
import OverAllReports from "./pages/Principal_Role/OverAllReports/OverAllReports";
import AddNewFeatureForm from "./pages/SuperAdmin/AddNewFeatureForm";
import AddFeatureList from "./pages/SuperAdmin/AddFeatureList";
import QuestionFormCard from "./pages/SuperAdmin/QuestionFormCard";
import TalentTestMiniDashboard from "./pages/SuperAdmin/TalentTest/TalentTestMiniDashboard";
import FinalSelectedQuestions from "./pages/SuperAdmin/TalentTest/FinalSelectedQuestions";
import StudentsTestResults from "./pages/SuperAdmin/TalentTest/StudentsTestResults";
import TopPerformersResults from "./pages/SuperAdmin/TalentTest/TopPerformersResults";
import PrincipalEditHostelfeeList from "./pages/Principal_Role/UpdateHostelfeeDetailsList/PrincipalEditHostelfeeList";
import Bonafide4 from "./pages/Fees_Admission_Department/UploadDocuments/Bonafide4";
import StudentApplicationList from "./pages/SuperAdmin/StudentApplicationList";
import Marketing from "./pages/Marketing/Marketing";

import Marketingg from "./pages/Marketing/Marketingg";
import Marketing3 from "./pages/Marketing/Marketing3";

import Shop from "./pages/Marketing/Shop"
import Order from "./pages/Marketing/Order";
import Ecommerce from "./pages/Marketing/Ecommerce/Ecommerce.js";
import ShopPage from "./pages/Marketing/Ecommerce/ShopPage.js";
import ProductPage from "./pages/Marketing/Ecommerce/ProductPage.js";
import CartPage from "./pages/Marketing/Ecommerce/CartPage.js";
import CheckoutPage from "./pages/Marketing/Ecommerce/CheckoutPage.js";
import UserDashboard from "./pages/Marketing/Ecommerce/UserDashboard.js";
import B2B from "./pages/Marketing/EcommerceFolder/B2B";
import B2BShopPage from "./pages/Marketing/EcommerceFolder/ecommerce/B2BShopPage";
import B2BProductPage from "./pages/Marketing/EcommerceFolder/ecommerce/B2BProductPage";
import B2BCartPage from "./pages/Marketing/EcommerceFolder/ecommerce/B2BCartPage";
import B2BCheckoutPage from "./pages/Marketing/EcommerceFolder/ecommerce/B2BCheckoutPage";
import B2BUserDashboard from "./pages/Marketing/EcommerceFolder/ecommerce/B2BUserDashboard";
import B2BRFQ from "./pages/Marketing/EcommerceFolder/ecommerce/B2BRFQ";
import B2BContracts from "./pages/Marketing/EcommerceFolder/ecommerce/B2BContracts";
import B2BOrders from "./pages/Marketing/EcommerceFolder/ecommerce/B2BOrders";
import Home from "./pages/Marketing/StoreB2B/Home.jsx";
import EstoreHome from "./pages/Marketing/Estore/EstoreHome.jsx";
import EstoreShop from "./pages/Marketing/Estore/pages/EstoreShop.jsx";
import EstoreProduct from "./pages/Marketing/Estore/pages/EstoreProduct.jsx";
import EstoreCart from "./pages/Marketing/Estore/pages/EstoreCart.jsx";
import EstoreCheckout from "./pages/Marketing/Estore/pages/EstoreCheckout.jsx";
import EstoreAccount from "./pages/Marketing/Estore/pages/EstoreAccount.jsx";

import product from "./pages/Marketing/Ecommerce/ProductPage.js";










const baseUrl = process.env.REACT_APP_API_BASE_URL;
const App = () => {
  const [theme, colorMode] = useMode();
  const location = useLocation();
  const [authenticated, setAuthenticated] = useState(false);
  const { loginEmail, role } = useAuth(); // Access authentication state// new code


  const [isOnline, setIsOnline] = useState(navigator.onLine);

// SERVER UNDER MAINTENANCE CODE
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState('');
  const [countdown, setCountdown] = useState(60 * 60); // 1 hour in seconds

  useEffect(() => {
    const checkServerHealth = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/maintenance/health`);

        if (!response.ok) {
          setIsMaintenance(true);
          setMaintenanceMessage(
            '⚠️ Server is unreachable. Please try again after <span style="color: red">1 hour</span>.'
          );
          return;
        }

        const data = await response.json();
        const message = data?.message;

        if (message?.includes('🚧 Server under maintenance')) {
          setIsMaintenance(true);
          setMaintenanceMessage(message);
        } else {
          setIsMaintenance(false);
          setMaintenanceMessage('');
          setCountdown(60 * 60); // reset if server is back
        }
      } catch (error) {
        console.error('Health check failed:', error);
        setIsMaintenance(true);
        setMaintenanceMessage('⚠️ Cannot reach the server. Please try again later.');
      }
    };

    checkServerHealth();
    const interval = setInterval(checkServerHealth, 60000); // check every minute
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!isMaintenance) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          return 60 * 60; // restart from 1 hour
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isMaintenance]);

  // ✅ Format countdown as HH:mm:ss
  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };


  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);



  const RequireAuth = ({ children }) => {
    // Check if the loginEmail is available in sessionStorage
    const loginEmail = sessionStorage.getItem("loginEmail");

    // Debugging: log the value of loginEmail
    console.log("loginEmail:", loginEmail);

    // If loginEmail is missing, user is not authenticated, redirect to login page
    if (!loginEmail) {
      // alert("You need to Log In to access this page.");
      return <Navigate to="/" replace />;
    }

    // If authenticated, render the children (protected routes)
    return children;
  };



  const checkAuthentication = () => {
    const publicRoutes = ["/", "/OrganizationForm"];
    const isPublicRoute = publicRoutes.includes(location.pathname);
    setAuthenticated(!isPublicRoute);
  };

  useEffect(() => {
    checkAuthentication();
  }, [location.pathname]);



  // Check if the current route is valid
  const isNotFound = () => {
    // Define regex for dynamic routes
    const validRoutes = [
      /^\/InvoiceTemplate$/,
       /^\/LoadingPage$/,
      /^\/ChangePassword$/,
      // if(role==="PRINCIPAL"){
      //   /^\/PrincipalDashboard$/,
      // }else if(role === "ORGANIZATION"){
      //   /^\/PrincipalDashboard\/([A-Za-z0-9-]+)$/,
      // },
      role === "PRINCIPAL" ? /^\/PrincipalDashboard$/ : null,
      role === "ORGANIZATION" ? /^\/PrincipalDashboard\/[A-Za-z0-9-]+$/ : null,

      /^\/PresentStudentsList$/,
      /^\/AbsentStudentsList$/,
      /^\/TotalTeachersList$/,
      /^\/PresentTeachersList$/,
      /^\/AbsentTeachersList$/,
      /^\/ScheduleNoticeBoard$/,
      /^\/IndividualComplaintsList$/,



      // /^\/Fees_Admission_DashBoard$/,
      /^\/UploadDocs$/,
      /^\/Expenses$/,
      /^\/AllStudentList$/,
      /^\/StudentApplicationList$/,
      /^\/Marketing$/,
       /^\/Ecommerce$/,
       /^\/Estore$/,
       /^\/EstoreShop$/,
       /^\/EstoreProduct$/,
       /^\/EstoreCart$/,
       /^\/EstoreCheckout$/,
       /^\/EstoreAccount$/,
       /^\/EDashboard$/,
       /^\/B2BShop$/,
       /^\/B2BProduct$/,
       /^\/B2BCart$/,
       /^\/B2BCheckout$/,
       /^\/B2BUser$/,
       /^\/B2BRFQ$/,
       /^\/B2BContracts$/,
       /^\/B2BOrders$/,

       /^\/Home$/,
       /^\/product$/,
       /^\/ShopPage$/,
       /^\/ProductPage$/,
       /^\/CartPage$/,
       /^\/CheckoutPage$/,
       /^\/UserDashboard$/,
      /^\/shop$/,
      /^\/order$/,
      /^\/Marketingg$/,
      /^\/Marketing3$/,
      

      /^\/StudentDetailView\/([A-Za-z0-9-]+)$/,
      /^\/StudentUpdateDetails\/([A-Za-z0-9-]+)$/,
      /^\/NewAdmissionForm$/,
      /^\/FeesDetailsList$/,
      // /^\/RolesRegistrationForm$/,
      /^\/BonafideCertificate$/,
      /^\/NoticeBoard$/,
      /^\/PrincipalRoleRegistrations$/,

      // HRBP ROLE
      /^\/AbsentsList$/,
      /^\/EmployeeAttendance$/,
      /^\/Dashboard$/,
      /^\/Employee$/,


      // /^\/EmployeeAttendanceDetails\/([A-Za-z0-9-]+)$/,
      /^\/EmployeeAttendanceDetails\/[A-Za-z0-9-]+\/[A-Za-z0-9-]+$/,
      /^\/EmployeeDetails\/[A-Za-z0-9-]+\/[A-Za-z0-9-]+$/,
      // /^\/EmployeeDetails\/([A-Za-z0-9-]+)$/, 
      /^\/EmployeeRegForm$/,
      /^\/HolidayCalendar$/,
      /^\/EmployeeLeave$/,
      /^\/EmployeePaySlip$/,
      /^\/PaySlipDoc$/,
      /^\/SalaryReport$/,

      // STORE ROLE
      /^\/StoreDashboard$/,
      /^\/StockItems$/,
      /^\/PurchaseInvoiceList$/,

      /^\/Store_Expenses$/,





      //Admission Role
      /^\/BranchTransfer$/,
      /^\/StudentTransferForm$/,
      /^\/StudentPromotion$/,
      /^\/StudentTransferList$/,
      /^\/Admission_DashBoard$/,
      /^\/PaidFeesList$/,
      /^\/UnPaidFeesList$/,
      /^\/BusFeesDetailsList$/,

      // /^\/BusFeeRegistrationForm$/,
      /^\/BusFeeRegistrationForm\/([A-Za-z0-9-]+)$/,
      /^\/PaidBusFeeList$/,
      /^\/UnpaidBusFeeList$/,

      /^\/TransferCertificate\/([A-Za-z0-9-]+)$/,
      /^\/TransferCertificate2\/([A-Za-z0-9-]+)$/,
      /^\/TransferCertificateList$/,
      /^\/StudentPromotionList$/,
      /^\/StudentBranchTransferList$/,
      /^\/ExistingStudentsList$/,




      //transport role
      /^\/TransportDashboard$/,
      /^\/TotalBusAttendanceList$/,
      /^\/PresentBusAttendeesList$/,
      /^\/AbsentBusAttendeesList$/,
      /^\/TransportReport$/,
      /^\/RoleRegistrationList$/,
      /^\/BusScheduleRouteForm$/,
      /^\/Trips$/,
      // /^\/StudentsAddBusList$/,
      /^\/StudentsAddBusList\/([A-Za-z0-9-_]+)$/,





      //Schedule and Meeting Role
      /^\/ScheduleAndMeetDashboard$/,
      /^\/TeachersClassSchedule$/,
      /^\/Teacherlist$/,
      /^\/TeacherTimeTable$/,
      /^\/AllClassSchedules$/,
      /^\/AddNewClassSchedules$/,
      /^\/BusExpenses$/,
      /^\/ClassTimeTable$/,
      /^\/SchedulingRouteList$/,
      /^\/SchedulingRouteForm$/,
      /^\/DriversList$/,
      /^\/DriverRegForm$/,
      /^\/TeacherMeeting$/,
      /^\/ParentMeetings$/,
      /^\/Notification$/,
      /^\/NewRegisterdStudents$/,
      /^\/NonTeachingStaffMeetings$/,


      //Organization
      /^\/OrganizationPrincipalRegistrationForm$/,
      /^\/OrganizationDashboard$/,
      /^\/OrganizationProfile$/,

      //Complaints
      /^\/Complaint$/,

      //Examination Role
      /^\/AllExaminationScheduleForm$/,
      /^\/AllExaminationScheduleList$/,
      /^\/ExaminationDashboard$/,
      /^\/AssignExamSubjectMarksForm$/,
      /^\/AssigenedExamSubjectMarksList$/,
      /^\/ExaminationMiniDashboard\/([A-Za-z0-9-_ ]+)$/,


      /^\/TodayandTmrwExaminationScheduleList$/,
      //  /^\/Unit1ExaminationScheduleList\/([A-Za-z0-9-]+)$/,
      /^\/Unit1ExaminationScheduleList\/([A-Za-z0-9-_]+)$/,
      // /^\/Unit1ExaminationResultList\/([A-Za-z0-9-]+)$/,
      /^\/Unit1ExaminationResultList\/([A-Za-z0-9-_]+)$/,
      // /^\/Unit1ExaminationIndividualResultList\/([A-Za-z0-9-]+)$/,
      /^\/Unit1ExaminationIndividualResultList\/([A-Za-z0-9-_]+)$/,


      // /^\/AnnualExaminationIndividualResultList$/,
      /^\/ProgressCard$/,
      /^\/ProgressCard2$/,
      /^\/ExaminationComplaints$/,
      /^\/SchedulesAndMeetComplaints$/,
      /^\/AdmissionComplaints$/,
      /^\/TransportComplaints$/,
      /^\/ClassTeacherForm$/,
      /^\/ClassTeachersList$/,

      /^\/PrincipalsList$/,
      /^\/PrincipalDetails\/([A-Za-z0-9-]+)$/,
      /^\/Settings$/,
      /^\/IntermediateSettings$/,

      /^\/StoreTotalStudentsList$/,
      /^\/AllStockItemsListForStudents\/([A-Za-z0-9-]+)$/,
      /^\/SoldItems$/,
      /^\/SoldItemsTemplate\/([A-Za-z0-9-]+)$/,
      /^\/AdmissionFeePayments$/,
      // /^\/StudentFeeConcessionForm$/,
      /^\/StudentFeeConcessionForm\/([A-Za-z0-9-]+)$/,
      /^\/StudentFeeConcessionList$/,
      /^\/ConcessionFeeList$/,
      /^\/PurchaseReceipt$/,
      /^\/PurchaseReceiptDummy$/,
      /^\/Organization_PrincipalDashboard\/([A-Za-z0-9-]+)$/,
      //  /^\/Hallticketslist\/([A-Za-z0-9-]+)$/,
      /^\/Hallticketslist\/([A-Za-z0-9-_]+)$/,

      /^\/BusTracking$/,
      //  /^\/BusTracking\/([A-Za-z0-9-_]+)$/,
      // /^\/BusFeeConcessionForm$/,
      /^\/BusFeeConcessionForm\/([A-Za-z0-9-]+)$/,
      /^\/BusFeeConcessionList$/,
      /^\/ConcessionBusFeeList$/,
      //  /^\/HallTicketTemplate$/,
      /^\/HallTicketTemplate\/[A-Za-z0-9-_]+\/[A-Za-z0-9-_]+$/,
      /^\/HallTicketTemplate2\/[A-Za-z0-9-_]+\/[A-Za-z0-9-_]+$/,
      /^\/HallTicketTemplate3\/[A-Za-z0-9-_]+\/[A-Za-z0-9-_]+$/,
      /^\/DigitalClasses$/,

      /^\/OrgDashTotalTeachersList$/,
      /^\/OrgDashPresentTeachersList$/,
      /^\/OrgDashAbsentTeachersList$/,

      /^\/OrgDashTotalStudentsList$/,
      /^\/OrgDashNewStudentsList$/,
      /^\/OrgDashExistingStudentsList$/,

      /^\/OrgDashTotalTutionFee$/,
      /^\/OrgDashPaidTutionFee$/,
      /^\/OrgDashUnPaidTutionFee$/,

      /^\/OrgDashTotalBusFee$/,
      /^\/OrgDashPaidBusFee$/,
      /^\/OrgDashUnPaidBusFee$/,

      /^\/BonafideDoc\/([A-Za-z0-9-]+)$/,
      /^\/Bonafide2\/([A-Za-z0-9-]+)$/,
      /^\/Bonafide3\/([A-Za-z0-9-]+)$/,
       /^\/Bonafide4\/([A-Za-z0-9-]+)$/,

      /^\/FeePayments$/,
      /^\/StudentPaymentList\/([A-Za-z0-9-]+)$/,
      //  /^\/StudentPaymentsTransactionList\/([A-Za-z0-9-]+)$/,
      /^\/StudentPaymentsTransactionList\/[A-Za-z0-9-_]+\/[A-Za-z0-9-_]+$/,
      /^\/StudentPaymentsReceipts\/[A-Za-z0-9-_]+\/[A-Za-z0-9-_]+$/,
      //  /^\/StudentPaymentsReceipts\/([A-Za-z0-9-]+)$/,
      /^\/ExamFees$/,
      /^\/OtherFees$/,

      //Reports
      /^\/PrincipalReports$/,
      /^\/AdmissionReportsScreen$/,
      /^\/NewAdmissionReports$/,
      /^\/AdmissionFeePaidReports$/,
      /^\/TuitionFeePaidReports$/,
      /^\/TuitionFeeUnpaidReports$/,
      /^\/BusFeePaidReports$/,
      /^\/BusFeeUnpaidReports$/,
      /^\/AdmissionExpensesReports$/,
      /^\/HRBPReportsScreen$/,
      /^\/EmployeeSalaryReports$/,
      /^\/EmployeePresentReports$/,
      /^\/EmployeeAbsentReports$/,
      /^\/TransportReportsScreen$/,
      /^\/StudentBusReports$/,
      /^\/StudentsBusWiseReports\/([A-Za-z0-9-]+)$/,

      /^\/TransportExpensesReports$/,
      /^\/ExpensesReportsScreen$/,
      /^\/StoreReportsScreen$/,
      /^\/PurchaseReports$/,
      /^\/SoldItemsReports$/,
      /^\/StockItemsMaterialReports$/,
      /^\/StoreExpensesReports$/,
      /^\/HRBPExpensesReportScreen$/,
      /^\/StoreExpensesReportsScreen$/,

      //superadmin
      /^\/SuperAdminDashboard$/,
      /^\/Packages$/,
      /^\/SuperAdminOrganizationsList$/,
      /^\/SuperAdminPrincipalsList$/,

      /^\/CashFeeReceipt$/,
      /^\/BooksFeeList$/,
      //  /^\/IndividualStudentsBooksList\/([A-Za-z0-9 _-]+)$/
      /^\/IndividualStudentsBooksList\/[A-Za-z0-9 -_]+\/[A-Za-z0-9 -_]+$/,

      /^\/BooksReceipt\/([A-Za-z0-9 _-]+)$/,
      /^\/LeisurePeriod$/,
      /^\/HostelFeesList$/,
      /^\/HostelRegistrationForm\/([A-Za-z0-9-]+)$/,
      /^\/StudentMarksUpload$/,
      /^\/StudentReportCard$/,
      /^\/SubjectCategoryMarksType$/,
      /^\/StudentMarksList$/,
      /^\/StudentIndividualMarksList$/,
      /^\/StudentAttendance$/,
      /^\/StudentAttendanceReport$/,
      // /^\/StudentAttendanceCalendar$/,
      // /^\/StudentAttendanceCalendar\/([A-Za-z0-9 _-]+\/[A-Za-z0-9-_] )$/,

       /^\/PrincipalEditTuitionFeeList$/,
        /^\/PrincipalEditBusFeeList$/,
        /^\/PrincipalEditFeeTransactionList\/[A-Za-z0-9-_]+\/[A-Za-z0-9-_]+$/,
      /^\/StudentAttendanceCalendar\/[A-Za-z0-9 -_]+\/[A-Za-z0-9 -_]+$/,

       /^\/PrincipalEditHostelfeeList$/,
     

       /^\/OverAllReports$/,
       /^\/AddNewFeatureForm$/,
       /^\/AddFeatureList$/,
       /^\/QuestionFormCard$/,
        /^\/TalentTestMiniDashboard\/([A-Za-z0-9\-_.%]+)$/,
         /^\/FinalSelectedQuestions\/([A-Za-z0-9-_.%]+)$/,
          /^\/StudentsTestResults\/([A-Za-z0-9-_.%]+)$/,
           /^\/TopPerformersResults\/([A-Za-z0-9-_.%]+)$/,




    ].filter(Boolean);          // ⬅️ remove nulls

    // Rest of your code


    return !validRoutes.some((route) => route.test(location.pathname));
    /* return TRUE if the path is unknown */

  };

  if (!isOnline) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '100vw',
        backgroundColor: '#111',
        color: 'white',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'sans-serif',
        padding: '20px',
      }}>
        <h1 style={{ fontSize: '32px', marginBottom: '10px' }}>⚠️ No Internet Connection</h1>
        <p style={{ fontSize: '18px', marginBottom: '30px', opacity: 0.8 }}>
          You are offline. Please check your network and try again.
        </p>
        <button
          onClick={() => {
            if (navigator.onLine) {
              window.location.reload(); // or setIsOnline(true);
            }
          }}
          style={{
            padding: '14px 32px',
            fontSize: '16px',
            fontWeight: 'bold',
            background: 'linear-gradient(135deg, #00C9FF 0%, #92FE9D 100%)',
            color: '#111',
            border: 'none',
            borderRadius: '50px',
            cursor: 'pointer',
            boxShadow: '0 8px 20px rgba(0, 201, 255, 0.4)',
            transition: 'all 0.3s ease-in-out',
            letterSpacing: '1px',
            textTransform: 'uppercase',
          }}
          onMouseOver={(e) => {
            e.target.style.boxShadow = '0 12px 30px rgba(0, 201, 255, 0.6)';
            e.target.style.transform = 'scale(1.05)';
          }}
          onMouseOut={(e) => {
            e.target.style.boxShadow = '0 8px 20px rgba(0, 201, 255, 0.4)';
            e.target.style.transform = 'scale(1)';
          }}
        >
          🔄 Retry Connection
        </button>

      </div>
    );
  }


  // 🚧 Maintenance Screen UI
  if (isMaintenance) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100vh',
          width: '100vw',
          background: 'linear-gradient(135deg, #2f2f35, #5f5c6b)',
          color: '#fff',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontFamily: 'Segoe UI, sans-serif',
          padding: '20px',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            backgroundColor: '#1e1e24',
            padding: '40px 30px',
            borderRadius: '12px',
            maxWidth: '600px',
            width: '100%',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
          }}
        >
          <h1
            style={{
              fontSize: '28px',
              color: '#FFA500',
              marginBottom: '20px',
              lineHeight: 1.4,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            🚧 The Application is Under Maintenance
          </h1>

          <p
            style={{
              fontSize: '16px',
              marginBottom: '20px',
              color: '#00ffcc',
              backgroundColor: '#2c2c2c',
              padding: '14px 24px',
              borderRadius: '8px',
              fontWeight: 500,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
            dangerouslySetInnerHTML={{ __html: maintenanceMessage }}
          />

          {/* ✅ Countdown Timer */}
          
          <p
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "20px",
              color: "#ff4d4d",
              textAlign: "center",
            }}
          >
            ⏳ <span style={{ color: "#aaa" }}>Estimated Time Remaining:</span>{" "}
            <span
              style={{
                color: "#ff1a1a",
                fontSize: "20px",
                fontWeight: "bolder",
                backgroundColor: "#fff0f0",
                padding: "4px 10px",
                borderRadius: "8px",
                border: "1px solid #ffcccc",
                display: "inline-block",
                minWidth: "90px",
                textAlign: "center",
              }}
            >
              {formatTime(countdown)}
            </span>
          </p>


          <p style={{ fontSize: '13px', color: '#aaa' }}>
            If the issue persists beyond the expected time, please contact support.
          </p>
        </div>
      </div>
    );
  }


  return (

    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* Handle authenticated routes */}
        {/* {authenticated ? ( */}

        {/* If the user is authenticated */}
        {authenticated && !isNotFound() ? (
          <MyProSidebarProvider>
            <div style={{ height: "100%", width: "100%" }}>

              <Topbar />
              <main>
                <Routes>
<Route path="/LoadingPage" element={<RequireAuth><LoadingPage /></RequireAuth>} />
                  {/* SuperAdmin */}
                  <Route path="/SuperAdminDashboard" element={<RequireAuth><SuperAdminDashboard /></RequireAuth>} />
                  <Route path="/Packages" element={<RequireAuth><Packages /></RequireAuth>} />
                  <Route path="/TopPerformersResults/:TestType" element={<RequireAuth><TopPerformersResults /></RequireAuth>} />
                  <Route path="/StudentsTestResults/:TestType" element={<RequireAuth><StudentsTestResults /></RequireAuth>} />
                  <Route path="/FinalSelectedQuestions/:TestType" element={<RequireAuth><FinalSelectedQuestions /></RequireAuth>} />
                  <Route path="/TalentTestMiniDashboard/:TestType" element={<RequireAuth><TalentTestMiniDashboard /></RequireAuth>} />
                  <Route path="/QuestionFormCard" element={<RequireAuth><QuestionFormCard /></RequireAuth>} />
                  <Route path="/AddNewFeatureForm" element={<RequireAuth><AddNewFeatureForm /></RequireAuth>} />
                  <Route path="/AddFeatureList" element={<RequireAuth><AddFeatureList /></RequireAuth>} />
                  <Route path="/SuperAdminOrganizationsList" element={<RequireAuth><SuperAdminOrganizationsList /></RequireAuth>} />
                  <Route path="/SuperAdminPrincipalsList" element={<RequireAuth><SuperAdminPrincipalsList /></RequireAuth>} />
                  {/* Reports*/}
                  <Route path="/PrincipalReports" element={<RequireAuth><PrincipalReports /></RequireAuth>} />
                  <Route path="/AdmissionReportsScreen" element={<RequireAuth><AdmissionReportsScreen /></RequireAuth>} />
                  <Route path="/NewAdmissionReports" element={<RequireAuth><NewAdmissionReports /></RequireAuth>} />
                  <Route path="/AdmissionFeePaidReports" element={<RequireAuth><AdmissionFeePaidReports /></RequireAuth>} />
                  <Route path="/TuitionFeePaidReports" element={<RequireAuth><TuitionFeePaidReports /></RequireAuth>} />
                  <Route path="/TuitionFeeUnpaidReports" element={<RequireAuth><TuitionFeeUnpaidReports /></RequireAuth>} />
                  <Route path="/BusFeePaidReports" element={<RequireAuth><BusFeePaidReports /></RequireAuth>} />
                  <Route path="/BusFeeUnpaidReports" element={<RequireAuth><BusFeeUnpaidReports /></RequireAuth>} />
                  <Route path="/AdmissionExpensesReports" element={<RequireAuth><AdmissionExpensesReports /></RequireAuth>} />
                  <Route path="/HRBPReportsScreen" element={<RequireAuth><HRBPReportsScreen /></RequireAuth>} />
                  <Route path="/EmployeeSalaryReports" element={<RequireAuth><EmployeeSalaryReports /></RequireAuth>} />
                  <Route path="/EmployeePresentReports" element={<RequireAuth><EmployeePresentReports /></RequireAuth>} />
                  <Route path="/EmployeeAbsentReports" element={<RequireAuth><EmployeeAbsentReports /></RequireAuth>} />
                  <Route path="/TransportReportsScreen" element={<RequireAuth><TransportReportsScreen /></RequireAuth>} />
                  <Route path="/StudentBusReports" element={<RequireAuth><StudentBusReports /></RequireAuth>} />
                  <Route path="/StudentsBusWiseReports/:busNumber" element={<RequireAuth><StudentsBusWiseReports /></RequireAuth>} />
                  <Route path="/TransportExpensesReports" element={<RequireAuth><TransportExpensesReports /></RequireAuth>} />
                  <Route path="/ExpensesReportsScreen" element={<RequireAuth><ExpensesReportsScreen /></RequireAuth>} />
                  <Route path="/StoreReportsScreen" element={<RequireAuth><StoreReportsScreen /></RequireAuth>} />
                  <Route path="/PurchaseReports" element={<RequireAuth><PurchaseReports /></RequireAuth>} />
                  <Route path="/HRBPExpensesReportScreen" element={<RequireAuth><HRBPExpensesReportScreen /></RequireAuth>} />
                  <Route path="/SoldItemsReports" element={<RequireAuth><SoldItemsReports /></RequireAuth>} />
                  <Route path="/StockItemsMaterialReports" element={<RequireAuth><StockItemsMaterialReports /></RequireAuth>} />
                  <Route path="/StoreExpensesReports" element={<RequireAuth><StoreExpensesReports /></RequireAuth>} />
                  <Route path="/StoreExpensesReportsScreen" element={<RequireAuth><StoreExpensesReportsScreen /></RequireAuth>} />

                  {/* Organization Role */}

                  <Route path="/OrganizationPrincipalRegistrationForm" element={<RequireAuth><OrganizationPrincipalRegistrationForm /></RequireAuth>} />
                  <Route path="/OrganizationDashboard" element={<RequireAuth><OrganizationDashboard /></RequireAuth>} />
                  <Route path="/PrincipalsList" element={<RequireAuth><PrincipalsList /></RequireAuth>} />
                  <Route path="/PrincipalDetails/:empId" element={<RequireAuth><PrincipalDetails /></RequireAuth>} />
                  <Route path="/Organization_PrincipalDashboard/:pid" element={<RequireAuth><Organization_PrincipalDashboard /></RequireAuth>} />
                  <Route path="/OrgDashTotalTeachersList" element={<RequireAuth><OrgDashTotalTeachersList /></RequireAuth>} />
                  <Route path="/OrgDashPresentTeachersList" element={<RequireAuth><OrgDashPresentTeachersList /></RequireAuth>} />
                  <Route path="/OrgDashAbsentTeachersList" element={<RequireAuth><OrgDashAbsentTeachersList /></RequireAuth>} />

                  <Route path="/OrgDashTotalStudentsList" element={<RequireAuth><OrgDashTotalStudentsList /></RequireAuth>} />
                  <Route path="/OrgDashNewStudentsList" element={<RequireAuth><OrgDashNewStudentsList /></RequireAuth>} />
                  <Route path="/OrgDashExistingStudentsList" element={<RequireAuth><OrgDashExistingStudentsList /></RequireAuth>} />

                  <Route path="/OrgDashTotalTutionFee" element={<RequireAuth><OrgDashTotalTutionFee /></RequireAuth>} />
                  <Route path="/OrgDashPaidTutionFee" element={<RequireAuth><OrgDashPaidTutionFee /></RequireAuth>} />
                  <Route path="/OrgDashUnPaidTutionFee" element={<RequireAuth><OrgDashUnPaidTutionFee /></RequireAuth>} />

                  <Route path="/OrgDashTotalBusFee" element={<RequireAuth><OrgDashTotalBusFee /></RequireAuth>} />
                  <Route path="/OrgDashPaidBusFee" element={<RequireAuth><OrgDashPaidBusFee /></RequireAuth>} />
                  <Route path="/OrgDashUnPaidBusFee" element={<RequireAuth><OrgDashUnPaidBusFee /></RequireAuth>} />
                  {/* role-specific dashboards */}
                  <Route
                    path="/PrincipalDashboard"
                    element={<RequireAuth><PrincipalDashboard /></RequireAuth>}
                  />
                  <Route
                    path="/PrincipalDashboard/:prId"
                    element={<RequireAuth><PrincipalDashboard /></RequireAuth>}
                  />

                  <Route path="/Bonafide3/:admissionNumber" element={<RequireAuth><Bonafide3 /></RequireAuth>} />
                  <Route path="/Bonafide2/:admissionNumber" element={<RequireAuth><Bonafide2 /></RequireAuth>} />
                  <Route path="/Bonafide4/:admissionNumber" element={<RequireAuth><Bonafide4 /></RequireAuth>} />


                  {/* Principal Role */}
                  <Route path="/OverAllReports" element={<RequireAuth><OverAllReports /></RequireAuth>} />
                  <Route path="/StudentAttendance" element={<RequireAuth><StudentAttendance /></RequireAuth>} />
                  <Route path="/StudentAttendanceReport" element={<RequireAuth><StudentAttendanceReport /></RequireAuth>} />
                  <Route path="/StudentAttendanceCalendar/:studentId/:romanNumberClass" element={<RequireAuth><StudentAttendanceCalendar /></RequireAuth>} />

                   <Route path="/PrincipalEditTuitionFeeList" element={<RequireAuth><PrincipalEditTuitionFeeList /></RequireAuth>} />
                  <Route path="/PrincipalEditBusFeeList" element={<RequireAuth><PrincipalEditBusFeeList /></RequireAuth>} />
                  <Route path="/PrincipalEditFeeTransactionList/:admissionNumber/:rolePayment" element={<RequireAuth><PrincipalEditFeeTransactionList /></RequireAuth>} />

                   <Route path="/PrincipalEditHostelfeeList" element={<RequireAuth><PrincipalEditHostelfeeList /></RequireAuth>} />

                  <Route path="/OrganizationProfile" element={<RequireAuth><OrganizationProfile /></RequireAuth>} />
                  <Route path="/ChangePassword" element={<RequireAuth><ChangePassword /></RequireAuth>} />
                  <Route path="/Settings" element={<RequireAuth><Settings /></RequireAuth>} />
                  <Route path="/IntermediateSettings" element={<RequireAuth><IntermediateSettings /></RequireAuth>} />
                  <Route path="/LeisurePeriod" element={<RequireAuth><LeisurePeriod /></RequireAuth>} />

                  {/* <Route path="/PrincipalDashboard" element={<RequireAuth><PrincipalDashboard /></RequireAuth>} /> */}
                  <Route path="/Admission_DashBoard" element={<RequireAuth><Admission_DashBoard /></RequireAuth>} />
                  <Route path="/IndividualComplaintsList" element={<RequireAuth><IndividualComplaintsList /></RequireAuth>} />
                  <Route path="/BusTracking" element={<RequireAuth><BusTracking /></RequireAuth>} />

                  <Route path="/UploadDocs" element={<RequireAuth><UploadDocs /></RequireAuth>} />
                  <Route path="/Expenses" element={<RequireAuth><Expenses /></RequireAuth>} />
                  <Route path="/AllStudentList" element={<RequireAuth><AllStudentList /></RequireAuth>} />
                  <Route path="/StudentApplicationList" element={<RequireAuth><StudentApplicationList /></RequireAuth>} />
                  <Route path="/Marketing" element={<RequireAuth><Marketing /></RequireAuth>} />
                  <Route path="/Ecommerce" element={<RequireAuth><Ecommerce/></RequireAuth>} />
                  <Route path="/Estore" element={<RequireAuth><EstoreHome/></RequireAuth>} />
                  <Route path="/EstoreShop" element={<RequireAuth><EstoreShop/></RequireAuth>} />
                  <Route path="/EstoreProduct" element={<RequireAuth><EstoreProduct/></RequireAuth>} />
                  <Route path="/EstoreCart" element={<RequireAuth><EstoreCart/></RequireAuth>} />
                  <Route path="/EstoreCheckout" element={<RequireAuth><EstoreCheckout/></RequireAuth>} />
                  <Route path="/EstoreAccount" element={<RequireAuth><EstoreAccount/></RequireAuth>} />
                  <Route path="/EDashboard" element={<RequireAuth><B2B/></RequireAuth>} />
                  <Route path="/B2BShop" element={<RequireAuth><B2BShopPage/></RequireAuth>} />
                  <Route path="/B2BProduct" element={<RequireAuth><B2BProductPage/></RequireAuth>} />
                  <Route path="/B2BCart" element={<RequireAuth><B2BCartPage/></RequireAuth>} />
                  <Route path="/B2BCheckout" element={<RequireAuth><B2BCheckoutPage/></RequireAuth>} />
                  <Route path="/B2BUser" element={<RequireAuth><B2BUserDashboard/></RequireAuth>} />
                  <Route path="/B2BRFQ" element={<RequireAuth><B2BRFQ/></RequireAuth>} />
                  <Route path="/B2BContracts" element={<RequireAuth><B2BContracts/></RequireAuth>} />
                  <Route path="/B2BOrders" element={<RequireAuth><B2BOrders/></RequireAuth>} />


                 <Route path="/Home" element={<RequireAuth><Home/></RequireAuth>} />
                 <Route path="/product" element={<RequireAuth><ProductPage/></RequireAuth>} />
                 

                  
                  <Route path="/ShopPage" element={<RequireAuth><ShopPage/></RequireAuth>} />
                  <Route path="/ProductPage" element={<RequireAuth><ProductPage/></RequireAuth>} />
                  <Route path="/CartPage" element={<RequireAuth><CartPage/></RequireAuth>} />
                  <Route path="/CheckoutPage" element={<RequireAuth><CheckoutPage/></RequireAuth>} />
                  <Route path="/UserDashboard" element={<RequireAuth><UserDashboard/></RequireAuth>} />
                  <Route path="/shop" element={<RequireAuth><Shop /></RequireAuth>} />
                  <Route path="/Order" element={<RequireAuth><Order /></RequireAuth>} />
                  <Route path="/Marketingg" element={<RequireAuth><Marketingg /></RequireAuth>} />
                  <Route path="/Marketing3" element={<RequireAuth><Marketing3 /></RequireAuth>} />
                  <Route path="/StudentDetailView/:studentId" element={<RequireAuth><StudentDetailView /></RequireAuth>} />
                  <Route path="/NewAdmissionForm" element={<RequireAuth><NewAdmissionForm /></RequireAuth>} />
                  <Route path="/FeesDetailsList" element={<RequireAuth><FeesDetailsList /></RequireAuth>} />
                  {/* <Route path="/RolesRegistrationForm" element={<RequireAuth><RolesRegistrationForm /></RequireAuth>} /> */}
                  <Route path="/BonafideCertificate" element={<RequireAuth><BonafideCertificate /></RequireAuth>} />
                  <Route path="/Complaint" element={<RequireAuth><Complaint /></RequireAuth>} />
                  <Route path="/PresentStudentsList" element={<RequireAuth><PresentStudentsList /></RequireAuth>} />
                  <Route path="/AbsentStudentsList" element={<RequireAuth><AbsentStudentsList /></RequireAuth>} />
                  <Route path="/TotalTeachersList" element={<RequireAuth><TotalTeachersList /></RequireAuth>} />
                  <Route path="/PresentTeachersList" element={<RequireAuth><PresentTeachersList /></RequireAuth>} />
                  <Route path="/AbsentTeachersList" element={<RequireAuth><AbsentTeachersList /></RequireAuth>} />
                  <Route path="/TotalBusAttendanceList" element={<RequireAuth><TotalBusAttendanceList /></RequireAuth>} />
                  <Route path="/PresentBusAttendeesList" element={<RequireAuth><PresentBusAttendeesList /></RequireAuth>} />
                  <Route path="/AbsentBusAttendeesList" element={<RequireAuth><AbsentBusAttendeesList /></RequireAuth>} />
                  <Route path="/ScheduleNoticeBoard" element={<RequireAuth><ScheduleNoticeBoard /></RequireAuth>} />
                  <Route path="/NoticeBoard" element={<RequireAuth><NoticeBoard /></RequireAuth>} />
                  <Route path="/PrincipalRoleRegistrations" element={<RequireAuth><PrincipalRoleRegistrations /></RequireAuth>} />

                  <Route path="/ConcessionBusFeeList" element={<RequireAuth><ConcessionBusFeeList /></RequireAuth>} />
                  <Route path="/CashFeeReceipt" element={<RequireAuth><CashFeeReceipt /></RequireAuth>} />


                  {/* HRBP ROLE*/}
                  <Route path="/AllClassSchedules" element={<RequireAuth><AllClassSchedules /></RequireAuth>} />
                  <Route path="/AddNewClassSchedules" element={<RequireAuth><AddNewClassSchedules /></RequireAuth>} />

                  {/* Admission ROLE*/}
                  <Route path="/BranchTransfer" element={<RequireAuth><BranchTransfer /></RequireAuth>} />
                  <Route path="/BooksFeeList" element={<RequireAuth><BooksFeeList /></RequireAuth>} />
                  <Route path="/StudentTransferForm" element={<RequireAuth><StudentTransferForm /></RequireAuth>} />
                  <Route path="/StudentPromotion" element={<RequireAuth><StudentPromotion /></RequireAuth>} />
                  <Route path="/StudentTransferList" element={<RequireAuth><StudentTransferList /></RequireAuth>} />
                  <Route path="/PaidFeesList" element={<RequireAuth><PaidFeesList /></RequireAuth>} />
                  <Route path="/UnPaidFeesList" element={<RequireAuth><UnPaidFeesList /></RequireAuth>} />
                  <Route path="/BusFeesDetailsList" element={<RequireAuth><BusFeesDetailsList /></RequireAuth>} />
                  <Route path="/BusFeeRegistrationForm/:studentId" element={<RequireAuth><BusFeeRegistrationForm /></RequireAuth>} />
                  <Route path="/PaidBusFeeList" element={<RequireAuth><PaidBusFeeList /></RequireAuth>} />
                  <Route path="/UnpaidBusFeeList" element={<RequireAuth><UnpaidBusFeeList /></RequireAuth>} />
                  <Route path="/BonafideDoc/:admissionNumber" element={<RequireAuth><BonafideDoc /></RequireAuth>} />
                  <Route path="/BusExpenses" element={<RequireAuth><BusExpenses /></RequireAuth>} />
                  <Route path="/TransferCertificate/:tcId" element={<RequireAuth><TransferCertificate /></RequireAuth>} />
                  <Route path="/TransferCertificate2/:tcId" element={<RequireAuth><TransferCertificate2 /></RequireAuth>} />
                  <Route path="/AdmissionComplaints" element={<RequireAuth><AdmissionComplaints /></RequireAuth>} />
                  <Route path="/TransferCertificateList" element={<RequireAuth><TransferCertificateList /></RequireAuth>} />
                  <Route path="/StudentPromotionList" element={<RequireAuth><StudentPromotionList /></RequireAuth>} />
                  <Route path="/StudentBranchTransferList" element={<RequireAuth><StudentBranchTransferList /></RequireAuth>} />
                  <Route path="/ExistingStudentsList" element={<RequireAuth><ExistingStudentsList /></RequireAuth>} />
                  <Route path="/StudentUpdateDetails/:studentId" element={<RequireAuth><StudentUpdateDetails /></RequireAuth>} />
                  <Route path="/AdmissionFeePayments" element={<RequireAuth><AdmissionFeePayments /></RequireAuth>} />
                  <Route path="/StudentFeeConcessionForm/:studentId" element={<RequireAuth><StudentFeeConcessionForm /></RequireAuth>} />
                  <Route path="/StudentFeeConcessionList" element={<RequireAuth><StudentFeeConcessionList /></RequireAuth>} />
                  <Route path="/ConcessionFeeList" element={<RequireAuth><ConcessionFeeList /></RequireAuth>} />
                  <Route path="/BusFeeConcessionForm/:studentId" element={<RequireAuth><BusFeeConcessionForm /></RequireAuth>} />
                  <Route path="/BusFeeConcessionList" element={<RequireAuth><BusFeeConcessionList /></RequireAuth>} />
                  <Route path="/FeePayments" element={<RequireAuth><FeePayments /></RequireAuth>} />
                  <Route path="/StudentPaymentList/:admissionNumber" element={<RequireAuth><StudentPaymentList /></RequireAuth>} />
                  <Route path="/StudentPaymentsTransactionList/:admissionNumber/:rolePayment" element={<RequireAuth><StudentPaymentsTransactionList /></RequireAuth>} />
                  <Route path="/StudentPaymentsReceipts/:admissionNumber/:rolePayment" element={<RequireAuth><StudentPaymentsReceipts /></RequireAuth>} />
                  <Route path="/ExamFees" element={<RequireAuth><ExamFees /></RequireAuth>} />
                  <Route path="/OtherFees" element={<RequireAuth><OtherFees /></RequireAuth>} />
                  <Route path="/IndividualStudentsBooksList/:Class/:studentId/:fullName" element={<RequireAuth><IndividualStudentsBooksList /></RequireAuth>} />
                  <Route path="/BooksReceipt/:billNo" element={<RequireAuth><BooksReceipt /></RequireAuth>} />
                  <Route path="/HostelFeesList" element={<RequireAuth><HostelFeesList /></RequireAuth>} />
                  <Route path="/HostelRegistrationForm/:studentId" element={<RequireAuth><HostelRegistrationForm /></RequireAuth>} />
                  {/* Examination ROLE*/}
                  <Route path="/AllExaminationScheduleList" element={<RequireAuth><AllExaminationScheduleList /></RequireAuth>} />
                  <Route path="/AllExaminationScheduleForm" element={<RequireAuth><AllExaminationScheduleForm /></RequireAuth>} />
                  <Route path="/ExaminationDashboard" element={<RequireAuth><ExaminationDashboard /></RequireAuth>} />
                  <Route path="/ExaminationMiniDashboard/:Examtype" element={<RequireAuth><ExaminationMiniDashboard /></RequireAuth>} />
                  <Route path="/TodayandTmrwExaminationScheduleList" element={<RequireAuth><TodayandTmrwExaminationScheduleList /></RequireAuth>} />

                  <Route path="/Unit1ExaminationScheduleList/:Examtype" element={<RequireAuth><Unit1ExaminationScheduleList /></RequireAuth>} />

                  <Route path="/HallTicketTemplate/:admissionNumber/:Examtype" element={<RequireAuth><HallTicketTemplate /></RequireAuth>} />
                  <Route path="/HallTicketTemplate2/:admissionNumber/:Examtype" element={<RequireAuth><HallTicketTemplate2 /></RequireAuth>} />
                  <Route path="/HallTicketTemplate3/:admissionNumber/:Examtype" element={<RequireAuth><HallTicketTemplate3 /></RequireAuth>} />
                  <Route path="/Hallticketslist/:Examtype" element={<RequireAuth><Hallticketslist /></RequireAuth>} />

                  <Route path="/Unit1ExaminationResultList/:Examtype" element={<RequireAuth><Unit1ExaminationResultList /></RequireAuth>} />
                  <Route path="/Unit1ExaminationIndividualResultList/:Examtype" element={<RequireAuth><Unit1ExaminationIndividualResultList /></RequireAuth>} />
                  <Route path="/AssignExamSubjectMarksForm" element={<RequireAuth><AssignExamSubjectMarksForm /></RequireAuth>} />
                  <Route path="/AssigenedExamSubjectMarksList" element={<RequireAuth><AssigenedExamSubjectMarksList /></RequireAuth>} />

                  <Route path="/StudentMarksUpload" element={<RequireAuth><StudentMarksUpload /></RequireAuth>} />
                  <Route path="/SubjectCategoryMarksType" element={<RequireAuth><SubjectCategoryMarksType /></RequireAuth>} />
                  <Route path="/ProgressCard" element={<RequireAuth><ProgressCard /></RequireAuth>} />
                  <Route path="/ProgressCard2" element={<RequireAuth><ProgressCard2 /></RequireAuth>} />
                  <Route path="/StudentReportCard" element={<RequireAuth><StudentReportCard /></RequireAuth>} />

                  <Route path="/ExaminationComplaints" element={<RequireAuth><ExaminationComplaints /></RequireAuth>} />
                  {/* <Route path="/Hallticketslist" element={<RequireAuth><Hallticketslist/></RequireAuth>} /> */}
                  <Route path="/StudentMarksList" element={<RequireAuth><StudentMarksList /></RequireAuth>} />
                  <Route path="/StudentIndividualMarksList" element={<RequireAuth><StudentIndividualMarksList /></RequireAuth>} />



                  {/* Transport ROLE*/}
                  <Route path="/TransportDashboard" element={<RequireAuth><TransportDashboard /></RequireAuth>} />
                  <Route path="/TransportComplaints" element={<RequireAuth><TransportComplaints /></RequireAuth>} />
                  <Route path="/RoleRegistrationList" element={<RequireAuth><RoleRegistrationList /></RequireAuth>} />
                  <Route path="/BusScheduleRouteForm" element={<RequireAuth><BusScheduleRouteForm /></RequireAuth>} />
                  <Route path="/Trips" element={<RequireAuth><Trips /></RequireAuth>} />
                  <Route path="/StudentsAddBusList/:AllList" element={<RequireAuth><StudentsAddBusList /></RequireAuth>} />



                  {/* ScheduleAnd Meet ROLE*/}
                  <Route path="/ScheduleAndMeetDashboard" element={<RequireAuth><ScheduleAndMeetDashboard /></RequireAuth>} />
                  <Route path="/TeachersClassSchedule" element={<RequireAuth><TeachersClassSchedule /></RequireAuth>} />
                  <Route path="/TeacherTimeTable" element={<RequireAuth><TeacherTimeTable /></RequireAuth>} />
                  <Route path="/ClassTimeTable" element={<RequireAuth><ClassTimeTable /></RequireAuth>} />
                  <Route path="/SchedulingRouteList" element={<RequireAuth><SchedulingRouteList /></RequireAuth>} />
                  <Route path="/SchedulingRouteForm" element={<RequireAuth><SchedulingRouteForm /></RequireAuth>} />
                  <Route path="/DriversList" element={<RequireAuth><DriversList /></RequireAuth>} />
                  <Route path="/DriverRegForm" element={<RequireAuth><DriverRegForm /></RequireAuth>} />
                  <Route path="/TeacherMeeting" element={<RequireAuth><TeacherMeeting /></RequireAuth>} />
                  <Route path="/ParentMeetings" element={<RequireAuth><ParentMeetings /></RequireAuth>} />
                  <Route path="/Notification" element={<RequireAuth><Notification /></RequireAuth>} />
                  <Route path="/SchedulesAndMeetComplaints" element={<RequireAuth><SchedulesAndMeetComplaints /></RequireAuth>} />
                  <Route path="/NonTeachingStaffMeetings" element={<RequireAuth><NonTeachingStaffMeetings /></RequireAuth>} />
                  <Route path="/ClassTeacherForm" element={<RequireAuth><ClassTeacherForm /></RequireAuth>} />
                  <Route path="/ClassTeachersList" element={<RequireAuth><ClassTeachersList /></RequireAuth>} />
                  <Route path="/DigitalClasses" element={<RequireAuth><DigitalClasses /></RequireAuth>} />
                  <Route path="/Teacherlist" element={<RequireAuth><Teacherlist /></RequireAuth>} />







                  {/* HRBP ROLE*/}
                  <Route path="/AbsentsList" element={<RequireAuth><AbsentsList /></RequireAuth>} />
                  <Route path="/EmployeeAttendance" element={<RequireAuth><EmployeeAttendance /></RequireAuth>} />
                  <Route path="/Dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
                  <Route path="/Employee" element={<RequireAuth><Employee /></RequireAuth>} />
                  <Route path="/EmployeeAttendanceDetails/:empId/:employeeId" element={<RequireAuth><EmployeeAttendanceDetails /></RequireAuth>} />
                  <Route path="/EmployeeDetails/:empId/:employeeId" element={<RequireAuth><EmployeeDetails /></RequireAuth>} />
                  <Route path="/EmployeeRegForm" element={<RequireAuth><EmployeeRegForm /></RequireAuth>} />
                  <Route path="/HolidayCalendar" element={<RequireAuth><HolidayCalendar /></RequireAuth>} />
                  <Route path="/EmployeeLeave" element={<RequireAuth><EmployeeLeave /></RequireAuth>} />
                  <Route path="/EmployeePaySlip" element={<RequireAuth><EmployeePaySlip /></RequireAuth>} />
                  <Route path="/PaySlipDoc" element={<RequireAuth><PaySlipDoc /></RequireAuth>} />
                  <Route path="/SalaryReport" element={<RequireAuth><SalaryReport /></RequireAuth>} />

                  {/* STORE ROLE*/}
                  <Route path="/StoreDashboard" element={<RequireAuth><StoreDashboard /></RequireAuth>} />
                  <Route path="/StockItems" element={<RequireAuth><StockItems /></RequireAuth>} />
                  <Route path="/StoreTotalStudentsList" element={<RequireAuth><StoreTotalStudentsList /></RequireAuth>} />

                  <Route path="/Store_Expenses" element={<RequireAuth><Store_Expenses /></RequireAuth>} />
                  <Route path="/PurchaseInvoiceList" element={<RequireAuth><PurchaseInvoiceList /></RequireAuth>} />
                  <Route path="/PurchaseReceipt" element={<RequireAuth><PurchaseReceipt /></RequireAuth>} />
                  <Route path="/PurchaseReceiptDummy" element={<RequireAuth><PurchaseReceiptDummy /></RequireAuth>} />

                  <Route path="/NewRegisterdStudents" element={<RequireAuth><NewRegisterdStudents /></RequireAuth>} />


                  <Route path="/AllStockItemsListForStudents/:studentId" element={<RequireAuth><AllStockItemsListForStudents /></RequireAuth>} />
                  <Route path="/SoldItems/" element={<RequireAuth><SoldItems /></RequireAuth>} />
                  <Route path="/SoldItemsTemplate/:billNo" element={<RequireAuth><SoldItemsTemplate /></RequireAuth>} />

                  {/* Not found page */}
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </main>

            </div>
          </MyProSidebarProvider>

        ) : (
          <Routes>
            {/* Non-authenticated routes */}
            <Route path="/" element={<SignIn />} />
            <Route path="/OrganizationForm" element={<OrganizationForm />} />
            <Route path="*" element={<SignIn />} />
            {/* <Route path="*" element={<NotFoundPage />} /> */}
          </Routes>
        )}
      </ThemeProvider>
    </ColorModeContext.Provider>

  );
};

export default App;
